import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Nav,
  Card
} from 'react-bootstrap';

import {
  FaUsers,
  FaShoppingCart,
  FaBoxOpen
} from 'react-icons/fa';

import CustomersPage from './CustomersPage';
import AdminOrdersPage from './AdminOrdersPage';
import ProductList from './ProductList';

function AdminMainPage() {
  const [activeTab, setActiveTab] = useState('customers');

  const renderActivePage = () => {
    switch (activeTab) {
      case 'customers':
        return <CustomersPage />;

      case 'orders':
        return <AdminOrdersPage />;

      case 'products':
        return <ProductList />;

      default:
        return <CustomersPage />;
    }
  };

  const getPageTitle = () => {
    switch (activeTab) {
      case 'customers':
        return 'Customers';

      case 'orders':
        return 'Orders';

      case 'products':
        return 'Products';

      default:
        return 'Dashboard';
    }
  };

  return (
    <Container fluid className="bg-light min-vh-100 py-4">
      <Row>

        {/* Sidebar */}
        <Col lg={2} md={3} className="mb-3">
          <Card
            className="border-0 shadow-sm rounded-4 h-100"
            style={{
              position: 'sticky',
              top: '20px'
            }}
          >
            <Card.Body>
              <div className="mb-4">
                <h4 className="fw-bold text-primary">
                  Admin Panel
                </h4>

                <small className="text-muted">
                  Management Dashboard
                </small>
              </div>

              <Nav
                variant="pills"
                className="flex-column gap-2"
                activeKey={activeTab}
                onSelect={(selectedKey) => setActiveTab(selectedKey)}
              >
                <Nav.Item>
                  <Nav.Link
                    eventKey="customers"
                    className="rounded-3 d-flex align-items-center gap-2"
                  >
                    <FaUsers />
                    Customers
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link
                    eventKey="orders"
                    className="rounded-3 d-flex align-items-center gap-2"
                  >
                    <FaShoppingCart />
                    Orders
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link
                    eventKey="products"
                    className="rounded-3 d-flex align-items-center gap-2"
                  >
                    <FaBoxOpen />
                    Products
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Body>
          </Card>
        </Col>

        {/* Content */}
        <Col lg={10} md={9}>
          <Card className="border-0 shadow-sm rounded-4">
            <Card.Body>

              {/* Header */}
              <div className="mb-4">
                <h3 className="fw-bold mb-1">
                  {getPageTitle()}
                </h3>

                <p className="text-muted mb-0">
                  Manage your {getPageTitle().toLowerCase()}
                </p>
              </div>

              {renderActivePage()}

            </Card.Body>
          </Card>
        </Col>

      </Row>
    </Container>
  );
}

export default AdminMainPage;